import { createFileRoute } from "@tanstack/react-router";
import { ThemeSlot } from "../../themes/slots";

export const Route = createFileRoute("/c/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ThemeSlot slot="homePage" />;
}
